import { CANCEL_POLICY_COMPONENT_MAPPER } from "./ComponentMapper";
import type { CancelPolicyComponentRendererProps } from "./types";

export const ComponentRenderer = ({
  components,
  layout,
  mapper = CANCEL_POLICY_COMPONENT_MAPPER,
}: CancelPolicyComponentRendererProps) => {
  if (!components?.length) {
    return null;
  }

  const layoutMapper = mapper[layout] ?? {};

  return (
    <>
      {components.map((card) => {
        const CardComponent = layoutMapper[card.id];
        if (!CardComponent) {
          return null;
        }
        const props = card.data;
        const isObjectProps = props !== null && typeof props === "object";
        return isObjectProps ? (
          <CardComponent key={card.id} {...props} />
        ) : (
          <CardComponent key={card.id} data={props} />
        );
      })}
    </>
  );
};

export default ComponentRenderer;
